// extracted by mini-css-extract-plugin
export default {"content":"AppRoot_content__I1M1G"};